(function () {

	let boundScrollTopButton;

  const scrollTop = () => {
    const btnScrollTop = document.querySelector('.scroll-top');
		if (!btnScrollTop) return;

		if (boundScrollTopButton && boundScrollTopButton !== btnScrollTop) {
			boundScrollTopButton.onclick = null;
		}

		boundScrollTopButton = btnScrollTop;

		btnScrollTop.onclick = () => {
			window.scrollTo({top: 0, behavior: 'smooth'});
		}

		if (scrollY > document.documentElement.clientHeight) {
			btnScrollTop.classList.add('show');
		} else {
			btnScrollTop.classList.remove('show');
		}
  }

	if (document.documentElement.dataset.scrollTopBound !== 'true') {
		document.documentElement.dataset.scrollTopBound = 'true';
		window.addEventListener('scroll', scrollTop);
	}

  scrollTop();

  document.addEventListener("shopify:section:load", function () {
    scrollTop();
  })

})()